<script lang="ts">
	import { t } from 'svelte-i18n';
	import { capitalize } from '$lib/utils/strings';
	import type { OperationModel } from '../../../models/api/OperationModel';
	import Map from '$lib/modules/Map.svelte';
	import type { MapCluster } from '$lib/types/props';
	import ContactMarkerPopup from '../../ContactMarkerPopup.svelte';
	import { readableAddress } from '../../../models/api/AddressModel';

	export let operation: OperationModel;

	let mapProps: MapCluster[] =
		operation.address && operation.address.latitude && operation.address.longitude
			? [
					{
						lat: operation.address.latitude ?? 0,
						long: operation.address.longitude ?? 0,
						markers: [
							{
								lat: operation.address.latitude ?? 0,
								long: operation.address.longitude ?? 0,
								popupContent: {
									component: ContactMarkerPopup,
									props: {
										label: capitalize(operation.name),
										address: readableAddress(operation.address)
									}
								}
							}
						]
					}
			  ]
			: [];
</script>

{#if mapProps.length}
	<section>
		<h2>{capitalize($t('operation.localisation'))}</h2>
		<p>{@html operation.localization}</p>
		<Map
			clusters={mapProps}
			initialPointOfView={[operation.address.latitude, operation.address.longitude]}
		/>
	</section>
{/if}
